const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
const MAP_ID = process.env.MAP_ID;

export const mapOptions = {
  googleMapApiKey: GOOGLE_MAPS_API_KEY,
  mapId: MAP_ID
}